export default __webpack_public_path__ + "static/minus-6dc16c2a9795ac9981c142ddb00a1fcb.svg";